"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldsModalClose = exports.fieldsModalOpen = void 0;
const ReportsFieldsModalActionTypes = require("../../actionTypes/reports/fieldsModal");
const fieldsModalOpen = (payload) => ({
    type: ReportsFieldsModalActionTypes.FIELDS_MODAL_OPEN,
    payload
});
exports.fieldsModalOpen = fieldsModalOpen;
const fieldsModalClose = () => ({
    type: ReportsFieldsModalActionTypes.FIELDS_MODAL_CLOSE
});
exports.fieldsModalClose = fieldsModalClose;
//# sourceMappingURL=fieldsModal.js.map